import { render, staticRenderFns } from "./msgSet.vue?vue&type=template&id=0b882ae3"
import script from "./msgSet.vue?vue&type=script&lang=js"
export * from "./msgSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b882ae3')) {
      api.createRecord('0b882ae3', component.options)
    } else {
      api.reload('0b882ae3', component.options)
    }
    module.hot.accept("./msgSet.vue?vue&type=template&id=0b882ae3", function () {
      api.rerender('0b882ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/msgSet.vue"
export default component.exports